import { pipe } from "fp-ts/lib/function";
import { TStaffUser2 } from "../../../../../domain/codecs/User";
import { TRoadblockAwaitableEntity, TRoadblockForm } from "../../../../../domain/codecs/form/RoadblockForm"
import { awaitDaysMaxFor } from "../../../../../domain/codecs/form/ChatsMessageForm";
import { array } from "fp-ts";
import { TCommand } from "../CRMRoadblockRichTextArea/CRMRoadblockRichTextArea";

const BaseCommands: Array<TCommand> = [
    {
        action: "add-check-item"
    }
];

export const createRoadblockCommandList = (form: TRoadblockForm): Array<TCommand> =>
    createCommandList(form.children.participants, form.children.awaitable_entities || []);

export const createCommandList = (participants: Array<TStaffUser2>, awaitableEntities: Array<TRoadblockAwaitableEntity>): Array<TCommand> =>
    array.flatten([
        BaseCommands,
        createCommandPerParticipant("assign", participants),
        createCommandPerAwaitableEntity(awaitableEntities),
    ]);

const createCommandPerParticipant = (action: "assign", participants: Array<TStaffUser2>): Array<TCommand> =>
    pipe(
        participants,
        array.filter(({ crm_username }) => crm_username.length > 0),    
        array.map(({ crm_username }) => ({
            action,
            target: crm_username
        }))
    )
;

const createCommandPerAwaitableEntity = (entities: Array<TRoadblockAwaitableEntity>): Array<TCommand> =>
    pipe(
        entities,
        array.map((entity) => ({
            action: "await",
            target: entity.name,
            maxDays: awaitDaysMaxFor(entity.is_internal)
        }))
    )
;